import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { VeiculoSensor } from "src/app/models/VeiculoSensor.model";
import { VwSensor } from "src/app/models/VwSensor.model";
import { EventEmitterSensorService } from "src/app/services/event-emitter-sensor.service";
import { ApiBaseService } from "src/app/services/migrate/api.base.service";
import {
  STORAGE_KEY_CURRENT_USER,
  STORAGE_KEY_ID_PERFIL,
} from "src/app/storageCore/constStorageKeys";
import storageX from "src/app/storageCore/storageX";
import Swal from "sweetalert2";
import { appendSensorToCombo, findVeiculoSensorByPosicaoId, findIncompleteSensorRows, alertIncompleteTpmsRows } from "src/app/utils/veiculo-sensor.util";

@Component({
  selector: "app-axle-six-dual",
  templateUrl: "./axle-six-dual.component.html",
  styleUrls: ["./axle-six-dual.component.scss"],
})
export class AxleSixDualComponent implements OnInit {
  @Input() veiculoSensores: any;
  @Input() sensoresDisponiveis: any;
  @Input() veiculoId: number;

  @Output() atualizarSensores = new EventEmitter<void>();

  public sensorSixIntLeftSelect: any = [];
  public sensorSixIntRightSelect: any = [];

  public sensorSixExtLeftSelect: any = [];
  public sensorSixExtRightSelect: any = [];

  public sensorSixIntRightCombo: any = [];
  public sensorSixIntLeftCombo: any = [];

  public sensorSixExtRightCombo: any = [];
  public sensorSixExtLeftCombo: any = [];

  public axisSixDoubleLeftIntForm: FormGroup;
  public axisSixDoubleLeftExtForm: FormGroup;
  public axisSixDoubleRightIntForm: FormGroup;
  public axisSixDoubleRightExtForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private serviceApiBase: ApiBaseService,
    private componentResetService: EventEmitterSensorService
  ) {}

  ngOnInit(): void {
    this.componentResetService.reiniciarComponentes$.subscribe(async (a) => {
      this.sensoresDisponiveis = null;
      this.veiculoSensores = null;
      this.sensorSixIntRightCombo = [];
      this.sensorSixIntLeftCombo = [];
      this.sensorSixExtRightCombo = [];
      this.sensorSixExtLeftCombo = [];

      const perfil = storageX.whereKeyIs(STORAGE_KEY_ID_PERFIL).get();

      const eixo = await this.serviceApiBase.get<any>({
        url: new VeiculoSensor()["nomeConsultaApiBase"] + this.veiculoId,
      });

      this.veiculoSensores = eixo["content"] ?? [];

      const sensor = await this.serviceApiBase.get<any>({
        url:
          new VwSensor()["nomeConsultaApiBaseSensor"] +
          this.veiculoId +
          "/perfil/" +
          perfil,
      });

      this.sensoresDisponiveis = sensor;

      if (this.sensoresDisponiveis.length > 0) {
        this.sensoresDisponiveis.forEach((element) => {
          this.sensorSixIntRightCombo.push(element);
          this.sensorSixIntLeftCombo.push(element);
          this.sensorSixExtRightCombo.push(element);
          this.sensorSixExtLeftCombo.push(element);
        });
      }

      this.loadSensor();
    });
    this.axisSixDoubleLeftIntForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.axisSixDoubleLeftExtForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.axisSixDoubleRightIntForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.axisSixDoubleRightExtForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    if (this.sensoresDisponiveis.length > 0) {
      this.sensoresDisponiveis.forEach((element) => {
        this.sensorSixExtRightCombo.push(element);
        this.sensorSixExtLeftCombo.push(element);
        this.sensorSixIntRightCombo.push(element);
        this.sensorSixIntLeftCombo.push(element);
      });
    }

    this.loadSensor();
  }

  public async loadSensor(): Promise<void> {
    try {
      this.spinner.show();
      this.axisSixDoubleLeftIntForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 6 ESQ INT"
      );
      this.axisSixDoubleLeftExtForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 6 ESQ EXT"
      );

      this.axisSixDoubleRightIntForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 6 DIR INT"
      );
      this.axisSixDoubleRightExtForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 6 DIR EXT"
      );

      if (this.veiculoSensores.length > 0) {
        const eixo6DireitoExt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          14
        );
        const eixo6EsquerdoExt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          13
        );
        const eixo6DireitoInt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          30
        );
        const eixo6EsquerdoInt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          29
        );

        // EIXO 6 DIREITO EXTERNO
        if (eixo6DireitoExt != null) {
          this.axisSixDoubleRightExtForm.controls["id"].setValue(
            eixo6DireitoExt.id
          );

          if (eixo6DireitoExt.sensor != null) {
            appendSensorToCombo(this.sensorSixExtRightCombo, eixo6DireitoExt.sensor);
            this.sensorSixExtRightSelect = eixo6DireitoExt.sensor.id;
          }

          if (eixo6DireitoExt.pneu != null) {
            this.axisSixDoubleRightExtForm.controls["pneu"].setValue(
              eixo6DireitoExt.pneu.numeroFogo
            );
          }

          this.axisSixDoubleRightExtForm.controls["nrPressaoMinima"].setValue(
            eixo6DireitoExt.nrPressaoMinima
          );

          this.axisSixDoubleRightExtForm.controls["nrPressaoMaxima"].setValue(
            eixo6DireitoExt.nrPressaoMaxima
          );

          this.axisSixDoubleRightExtForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo6DireitoExt.nrTemperaturaMaxima);
        }

        // EIXO 6 ESQUERDO EXTERNO
        if (eixo6EsquerdoExt != null) {
          this.axisSixDoubleLeftExtForm.controls["id"].setValue(
            eixo6EsquerdoExt.id
          );

          if (eixo6EsquerdoExt.sensor != null) {
            appendSensorToCombo(this.sensorSixExtLeftCombo, eixo6EsquerdoExt.sensor);
            this.sensorSixExtLeftSelect = eixo6EsquerdoExt.sensor.id;
          }

          if (eixo6EsquerdoExt.pneu != null) {
            this.axisSixDoubleLeftExtForm.controls["pneu"].setValue(
              eixo6EsquerdoExt.pneu.numeroFogo
            );
          }

          this.axisSixDoubleLeftExtForm.controls["nrPressaoMinima"].setValue(
            eixo6EsquerdoExt.nrPressaoMinima
          );

          this.axisSixDoubleLeftExtForm.controls["nrPressaoMaxima"].setValue(
            eixo6EsquerdoExt.nrPressaoMaxima
          );

          this.axisSixDoubleLeftExtForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo6EsquerdoExt.nrTemperaturaMaxima);
        }

        // EIXO 6 DIREITO INTERNO
        if (eixo6DireitoInt != null) {
          this.axisSixDoubleRightIntForm.controls["id"].setValue(
            eixo6DireitoInt.id
          );

          if (eixo6DireitoInt.sensor != null) {
            appendSensorToCombo(this.sensorSixIntRightCombo, eixo6DireitoInt.sensor);
            this.sensorSixIntRightSelect = eixo6DireitoInt.sensor.id;
          }

          if (eixo6DireitoInt.pneu != null) {
            this.axisSixDoubleRightIntForm.controls["pneu"].setValue(
              eixo6DireitoInt.pneu.numeroFogo
            );
          }

          this.axisSixDoubleRightIntForm.controls["nrPressaoMinima"].setValue(
            eixo6DireitoInt.nrPressaoMinima
          );

          this.axisSixDoubleRightIntForm.controls["nrPressaoMaxima"].setValue(
            eixo6DireitoInt.nrPressaoMaxima
          );

          this.axisSixDoubleRightIntForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo6DireitoInt.nrTemperaturaMaxima);
        }

        // EIXO 6 ESQUERDO INTERNO
        if (eixo6EsquerdoInt != null) {
          this.axisSixDoubleLeftIntForm.controls["id"].setValue(
            eixo6EsquerdoInt.id
          );

          if (eixo6EsquerdoInt.sensor != null) {
            appendSensorToCombo(this.sensorSixIntLeftCombo, eixo6EsquerdoInt.sensor);
            this.sensorSixIntLeftSelect = eixo6EsquerdoInt.sensor.id;
          }

          if (eixo6EsquerdoInt.pneu != null) {
            this.axisSixDoubleLeftIntForm.controls["pneu"].setValue(
              eixo6EsquerdoInt.pneu.numeroFogo
            );
          }

          this.axisSixDoubleLeftIntForm.controls["nrPressaoMinima"].setValue(
            eixo6EsquerdoInt.nrPressaoMinima
          );

          this.axisSixDoubleLeftIntForm.controls["nrPressaoMaxima"].setValue(
            eixo6EsquerdoInt.nrPressaoMaxima
          );

          this.axisSixDoubleLeftIntForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo6EsquerdoInt.nrTemperaturaMaxima);
        }
      }

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.error("loadVeiculo() error", error);
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  public async submitFormDelete(form: FormGroup): Promise<void> {
    this.spinner.show();
    try {
      const values = form.value;
      var post;

      post = {
        veiculo: {
          id: this.veiculoId,
        },
        nrPressaoMinima: values.nrPressaoMinima,
        nrPressaoMaxima: values.nrPressaoMaxima,
        nrTemperaturaMaxima: values.nrTemperaturaMaxima,
        sensor: {
          id: values.cdSensor,
        },
        pneu: null,
        idUsuario: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id,
      };

      console.log(post);

      const result = await this.serviceApiBase.put<VeiculoSensor>(
        values.id,
        new VeiculoSensor()["nomeConsultaApiBaseRemove"],
        post
      );

      form.get("cdSensor").setValue("");
      form.get("id").setValue("");

      this.spinner.hide();

      this.handleDelete();

      this.atualizarSensores.emit();
    } catch (error) {
      this.spinner.hide();
      //this.errorMessage = error.message;
      throw new EvalError(error);
    }
  }

  public async submitFormDeleteAll(): Promise<void> {
    this.spinner.show();
    try {
      var estepeArray: any = [];
      var posicoesPneusList: any = [];

      estepeArray.push(this.axisSixDoubleLeftExtForm.value);
      estepeArray.push(this.axisSixDoubleLeftIntForm.value);
      estepeArray.push(this.axisSixDoubleRightExtForm.value);
      estepeArray.push(this.axisSixDoubleRightIntForm.value);

      if (estepeArray.length > 0) {
        estepeArray.forEach((element) => {
          var posicaoPneuResquest = {
            cdPosicaoPneu: element.cdPosicaoPneu,
          };
          posicoesPneusList.push(posicaoPneuResquest);
        });
      }

      var post = {
        veiculoSensores: posicoesPneusList,
      };

      const result = await this.serviceApiBase.put<VeiculoSensor>(
        this.veiculoId,
        new VeiculoSensor()["nomeConsultaApiBaseRemoveAll"],
        post
      );

      this.axisSixDoubleLeftExtForm.get("cdSensor").setValue("");
      this.axisSixDoubleLeftExtForm.get("id").setValue("");
      this.axisSixDoubleLeftIntForm.get("cdSensor").setValue("");
      this.axisSixDoubleLeftIntForm.get("id").setValue("");
      this.axisSixDoubleRightExtForm.get("cdSensor").setValue("");
      this.axisSixDoubleRightExtForm.get("id").setValue("");
      this.axisSixDoubleRightIntForm.get("cdSensor").setValue("");
      this.axisSixDoubleRightIntForm.get("id").setValue("");

      this.spinner.hide();

      this.handleDeleteAll();

      this.atualizarSensores.emit();
    } catch (error) {
      this.spinner.hide();
      throw new EvalError(error);
    }
  }

  public async submitFormAddAll(): Promise<void> {
    var estepeArray: any = [];

      estepeArray.push(this.axisSixDoubleLeftExtForm.value);
      estepeArray.push(this.axisSixDoubleLeftIntForm.value);
      estepeArray.push(this.axisSixDoubleRightExtForm.value);
      estepeArray.push(this.axisSixDoubleRightIntForm.value);

    const posicoesIncompletas = findIncompleteSensorRows(estepeArray);
    if (posicoesIncompletas.length > 0) {
      await alertIncompleteTpmsRows(posicoesIncompletas);
      return;
    }

    if (estepeArray.length > 0 && this.verificarDuplicados(estepeArray)) {
      this.handleItensDuplicados();
      return;
    }

    var posicoesPneusList: any = [];

    estepeArray.forEach((element) => {
      if (element.cdSensor != "") {
        var posicaoPneuResquest = {
          cdPosicaoPneu: element.cdPosicaoPneu,
          cdSensor: element.cdSensor,
          pneu: element.pneu,
          nrPressaoMinima: element.nrPressaoMinima,
          nrPressaoMaxima: element.nrPressaoMaxima,
          nrTemperaturaMaxima: element.nrTemperaturaMaxima,
          idPerfil: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id,
        };
        posicoesPneusList.push(posicaoPneuResquest);
      }
    });

    if (posicoesPneusList.length === 0) {
      return;
    }

    this.spinner.show();
    try {
      var post = {
        veiculoSensores: posicoesPneusList,
      };

      const result = await this.serviceApiBase.put<VeiculoSensor>(
        this.veiculoId,
        new VeiculoSensor()["nomeConsultaApiBaseAddAll"],
        post
      );

      this.spinner.hide();

      this.handleAddAll();

      this.atualizarSensores.emit();
    } catch (error) {
      this.spinner.hide();
      throw new EvalError(error);
    }
  }


  verificarDuplicados(axisOneArray: any[]): boolean {
    const seen = new Set();
    for (const item of axisOneArray) {
      if (seen.has(item.cdSensor)) {
        return true; // Retorna true se encontrar um valor duplicado
      } else {
        seen.add(item.cdSensor);
      }
    }
    return false; // Retorna false se não houver valores duplicados
  }

  public async handleItensDuplicados(): Promise<void> {
    Swal.fire({
      icon: "warning",
      title: "Sensores selecionados estão com duplicidade, por favor corrigir!",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }

  public async handleAddAll(): Promise<void> {
    Swal.fire({
      icon: "success",
      title: "Sensores do EIXO 6 vinculados com sucesso",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }

  public async handleDeleteAll(): Promise<void> {
    Swal.fire({
      icon: "success",
      title: "Sensores do EIXO 6 desvinculados com sucesso",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }

  public async handleDelete(): Promise<void> {
    Swal.fire({
      icon: "success",
      title: "Sensor desvinculados com sucesso",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }
}
